import type { FeatureWithIDs } from '@/overmind/effects/adapters/baseadapter';

import * as actions from './actions';

type SelectedFeatureState = { current: FeatureWithIDs | undefined };

const state: SelectedFeatureState = { current: undefined };

export { state, actions };
